if (!window.Eurus.loadedScript.includes('lp-fsf.js')) {
    window.Eurus.loadedScript.push('lp-fsf.js');
}
const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
    window.Eurus.loadedScript.push(name);
    (events => {
        const loadScript = () => {
            events.forEach(type => window.removeEventListener(type, loadScript));
            clearTimeout(autoloadScript);
            const initScript = () => {
                const script = document.createElement('script');
                script.setAttribute('src', src);
                script.setAttribute('defer', '');
                script.onload = () => {
                    document.dispatchEvent(new CustomEvent(name + ' loaded'));
                    onload();
                };
                document.head.appendChild(script);
            };
            if (requestVisualChange) {
                if (window.requestIdleCallback) {
                    requestIdleCallback(initScript);
                }
                else {
                    requestAnimationFrame(initScript);
                }
            }
            else {
                initScript();
            }
        };
        let autoloadScript;
        const wait = window.innerWidth > 767 ? 2000 : 5000;
        events.forEach(type => window.addEventListener(type, loadScript, { once: true, passive: true }));
        autoloadScript = setTimeout(() => {
            loadScript();
        }, wait);
    })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
};
// alpine func
requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
        // global vars
        Alpine.store('global', {
            headerHeight: 94,
            kvScrolled: false,
            curtainOnLoad: {
                [':class']: "loaded && 'animate-(--animate-curtain)'"
            },
            fullCurtainOnLoad: {
                [':class']: "loaded && 'animate-(--animate-full-curtain)'"
            },
            curtainOnScroll: {
                ['x-intersect:enter.once']: "$el.classList.add('animate-(--animate-curtain)')"
            },
            fullCurtainOnScroll: {
                ['x-intersect:enter.once']: "$el.classList.add('animate-(--animate-full-curtain)')"
            },
            fullCurtainLeftOnScroll: {
                ['x-intersect:enter.once']: "$el.classList.add('animate-(--animate-full-curtain-left)')"
            },
            fadeInOnScroll: {
                ['x-intersect:enter.once']: "$el.classList.contains('opacity-0') && $el.classList.remove('opacity-0')"
            },
            mobileNav: false,
            toggleNav() {
                this.mobileNav = !this.mobileNav;
            },
            closeNav() {
                this.mobileNav = false;
            }
        }),
            Alpine.data('fsfHeader', () => ({
                stickyBind: {
                    [':class']: "$store.global.kvScrolled && 'sticky top-0'"
                },
                headerBind: {
                    [':class']: "$store.global.kvScrolled && 'animate-slide-down'"
                },
                heightGetter: {
                    ['x-init']: "$store.global.headerHeight = $el.getBoundingClientRect().height + 10",
                    ['@resize.window.throttle']: "$store.global.headerHeight = $el.getBoundingClientRect().height + 10"
                },
                headerBottom: {
                    [':class']: "$store.global.kvScrolled && 'hidden'"
                },
                cantBelieveIHaveToMakeABindJustForThisThing: {
                    [':class']: "{ 'hidden' : $store.global.kvScrolled, 'animate-(--animate-curtain)' : loaded }"
                },
                navTop: {
                    ['@click.prevent']: "scrollTo({ top: 0 , behavior: 'auto' })",
                },
                navTopMobile: {
                    ['@click.prevent']: "scrollTo({ top: 0 , behavior: 'auto' }); $store.global.closeNav();",
                },
                navItem: {
                    ['@click.prevent']: "scrollTo({ top: Math.floor(window.scrollY + document.querySelector($el.getAttribute('href')).getBoundingClientRect().top - $store.global.headerHeight) , behavior: 'auto' });"
                },
                navItemMobile: {
                    ['@click.prevent']: "scrollTo({ top: Math.floor(window.scrollY + document.querySelector($el.getAttribute('href')).getBoundingClientRect().top - $store.global.headerHeight) , behavior: 'auto' }); $store.global.closeNav();"
                },
                navDetails: {
                    ['x-effect']: "$el.toggleAttribute('open', $store.global.mobileNav)"
                },
                navBtn: {
                    ['@click.prevent']: "$store.global.toggleNav()",
                    [':aria-expanded']: "$store.global.mobileNav ? 'true' : 'false'",
                    [':class']: "$store.global.mobileNav ? 'bg-red text-black' : 'bg-black text-white'"
                },
                mobileNav: {
                    ['x-show']: "$store.global.mobileNav",
                    ['x-transition.opacity']: ""
                },
                navHamburger: {
                    ['x-show']: "!$store.global.mobileNav"
                },
                navClose: {
                    ['x-show']: "$store.global.mobileNav"
                },
            })),
            Alpine.data('fsfKv', () => ({
                kvBind: {
                    ['x-intersect:enter.full']: "$store.global.kvScrolled = false",
                    ['x-intersect:leave']: "$store.global.kvScrolled = true"
                }
            })),
            Alpine.data('loadingSplash', () => ({
                splashHide: {
                    [':class']: "loaded && 'opacity-0 pointer-events-none'",
                    ['x-effect']: "loaded && setTimeout(() => { $el.classList.replace('flex', 'hidden') }, 300);"
                }
            })),
            // mobile nav
            Alpine.store('lpMobileNav', {
                show: false,
                toggle() {
                    this.show = !this.show;
                },
                close() {
                    this.show = false;
                }
            });
    });
});
